import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { Api } from "../../../services/api";
import { I18N } from "aurelia-i18n";

@autoinject
export class LansitecTemperatureHumidityChart extends BaseDeviceChart {

	constructor(api: Api, i18N: I18N) {
		super(api, i18N);
	}

	attached() {
		setTimeout(() => {
				this.isAttached = true;
			},
			100);
	}
}
